
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: 'easeOut' }}
          className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6"
        >
          <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-100 p-6 md:p-8">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary/10 rounded-full">
                    <i className="ri-cookie-line text-primary text-xl"></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900">
                    Utilizamos cookies
                  </h3>
                </div>
                <p className="text-gray-600 text-[14px] leading-relaxed">
                  Usamos cookies propias y de terceros para mejorar tu experiencia de navegación, 
                  analizar el tráfico del sitio y personalizar el contenido. Al hacer clic en 
                  "Aceptar todas", consientes el uso de todas las cookies. Puedes rechazarlas 
                  o consultar nuestra{' '}
                  <a 
                    href="/contacto" 
                    className="text-primary hover:underline font-medium"
                  >
                    política de cookies
                  </a>
                  .
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                <button
                  onClick={handleReject}
                  className="px-6 py-3 text-[14px] font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-xl transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  Rechazar
                </button>
                <button
                  onClick={handleAccept}
                  className="px-6 py-3 text-[14px] font-medium text-white bg-primary hover:bg-primary/90 rounded-xl transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  Aceptar todas
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
